import { Link } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';
import Breadcrumb from '../../../../components/layout/Breadcrumb';

// ===== EN Related / Japan Butler Academy — full redesign (mirrors JA; _shared dropped). External URL unchanged. Own FAQ. =====

const points = [
  { no: '01', title: 'Training butlers', desc: 'It trains butlers through a structured curriculum, from essential to master levels.', img: '/images/generated/jba-still-globe-01.webp', alt: 'A globe and a sheep figurine, symbols of learning' },
  { no: '02', title: 'Issuing certified credentials', desc: 'It awards Association-certified butler credentials to those who complete the program and pass the practical examination, guaranteeing the quality of the talent it trains.', img: '/images/generated/jba-fs-185-related_butler-academy.webp', alt: 'Association-certified credentials and course materials' },
  { no: '03', title: 'Practice-oriented education', desc: 'Built on the discipline of the English butler and Japanese courtesy, students learn conduct and mindset that can be applied in real service settings.', img: '/images/generated/jba-fs-186-related_butler-academy-v6.webp', alt: 'Learning conduct and mindset for real service settings' },
  { no: '04', title: 'Connecting learning to practice', desc: 'Graduates put their skills to work in settings such as the butler service THE BUTLER, so learning and practice connect as one flow.', img: '/images/generated/jba-fs-187-related_butler-academy-v7.webp', alt: 'Graduates putting their skills to work in the field' },
];

const faqs = [
  {
    q: 'What kind of institution is Japan Butler Academy?',
    a: 'Japan Butler Academy is the education and training institution operated by the Japan Butler Association. It trains butlers through a structured curriculum and awards Association-certified credentials to those who complete the program and pass the practical examination.',
  },
  {
    q: 'What can I learn there?',
    a: 'Built on the discipline and dignity of the English butler and the attentive courtesy unique to Japan, students systematically learn conduct and mindset that can be applied in real service settings, such as table service, poise, and guest reception. A step-by-step curriculum runs from essential to master levels.',
  },
  {
    q: 'How is it related to the Association and butler service?',
    a: 'Japan Butler Academy is the education division operated by the Association. Butlers trained by the Academy put their skills to work in settings such as the butler service THE BUTLER, so learning and practice are connected under the same Association. For details, see the official site, butler-academy.jp.',
  },
];

const otherRelated = [
  { name: 'THE BUTLER', role: 'Butler service', to: '/en/related/the-butler' },
  { name: 'Butler Bell', role: 'Media brand', to: '/en/related/butler-bell' },
];

const breadcrumbs = [
  { label: 'Home', href: '/en/' },
  { label: 'Related Sites', href: '/en/related' },
  { label: 'Japan Butler Academy' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.06em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function EnRelatedButlerAcademyPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/generated/jba-still-cabinet-02.webp" alt="Study cabinet, a learning environment" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[700px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Japan Butler Academy</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.02em] mb-6">
              Where butlers are trained and certified
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.9]">
              The education and training institution operated by the Japan Butler Association. It trains butlers through a structured curriculum and awards Association-certified credentials to those who complete the program.
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* I. About */}
      <NavyBand no="I" ja="What is Japan Butler Academy?" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.01em] mb-5">
                A profession evaluated <span className="text-[#a38e65]">by clear standards</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                Japan Butler Academy is the education and training institution operated by the Japan Butler Association. The Association's ideal of raising the social value of the butler profession through training and certification forms the foundation of the Academy's approach.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                It trains butlers through a structured curriculum from essential to master levels, and awards Association-certified butler credentials to those who complete the program and pass the practical examination. By guaranteeing the quality of the talent it trains, it helps make butler etiquette something that can be applied in a wider range of settings.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9]">
                Positioning the butler not as a special occupation confined to a limited world, but as a profession evaluated by clear standards, is why the Association handles training and certification as one continuous effort.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-still-china-01.webp" alt="Gold-leaf Western tableware for teaching table manners" className="w-full h-[300px] sm:h-[400px] md:h-[480px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* II. Our Role */}
      <NavyBand no="II" ja="Four roles of the Academy" en="Our Role" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {points.map((p) => (
              <article key={p.no} className="flex flex-col sm:flex-row border border-[#e2ddd2] overflow-hidden group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative sm:w-[42%] shrink-0 h-48 sm:h-auto min-h-[190px]">
                  <img src={p.img} alt={p.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                  <span className="absolute top-3 left-3 font-['Playfair_Display',serif] text-[#f8f6f0] text-2xl drop-shadow-lg">{p.no}</span>
                </div>
                <div className="p-6 sm:p-7 flex flex-col justify-center text-left">
                  <h4 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-3 leading-[1.4]">{p.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* III. Relationship */}
      <NavyBand no="III" ja="Connection with the Association" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/generated/jba-p-027-rel-academy-w2.webp" alt="Butlers trained by the Academy putting their skills to work in the field" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.01em] mb-6">
                The education division, <span className="text-[#d7b779]">carrying the ideals</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9] mb-4">
                Japan Butler Academy is the education division operated by the Japan Butler Association. The Association's ideal of raising the social value of the profession through training and certification forms the foundation of the Academy's approach.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9]">
                Butlers trained by the Academy put their skills to work in settings such as the butler service THE BUTLER. That learning and practice connect under the same Association is a defining feature of the Academy's education.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IV. Official Site */}
      <NavyBand no="IV" ja="Official site" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">Japan Butler Academy official site</h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.9] max-w-2xl mx-auto mb-8">
              For details about courses, certified credentials, and learning, please visit the official site.
            </p>
            <a href="https://butler-academy.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              Visit the Japan Butler Academy official site <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* V. FAQ */}
      <NavyBand no="V" ja="Frequently asked questions" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other related + CTA */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">Other related sites</h3>
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">Interested in learning the butler craft?</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/en/qualifications" className={BTN08_ON_NAVY}>View certifications</Link>
              <Link to="/en/contact" className={BTN08_ON_NAVY}>Contact us</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
